import { LOGIN, LOGOUT, RESET_ACCOUNT_STATE, SET_USER_LOADED } from "./types";
import API from "../../utils/axios";
import jwt from "jsonwebtoken";
import { resetProject } from "./project";
import { setPayment, setBillingDetails } from "./account";
import { enqueueSnackbar } from "./snackbars";
import { setCookie, eraseCookie } from "../../utils/cookies";

export function setUser(userData) {
  return {
    type: LOGIN,
    userData
  };
}

export function setUserLoaded(bool) {
  return {
    type: SET_USER_LOADED,
    bool
  };
}

/**
 * Login actions
 * @param {string} token Access token
 * @param {string} expiresAt Access token expiry date
 * @param {string} refreshToken Refresh token
 */
export function login(token, expiresAt, refreshToken, from) {
  return (dispatch, getState) => {
    sessionStorage.clear();
    dispatch(resetProject());
    const decoded = jwt.decode(token, { complete: true });
    if (!decoded) {
      dispatch(logout());
      return;
    }
    const fullToken = `Bearer ${token}`;
    setCookie("accessToken", fullToken, 365);
    refreshToken && setCookie("refreshToken", refreshToken, 365);
    expiresAt && setCookie("expiresAt", expiresAt, 365);

    // Get project data
    API.defaults.headers.common["Authorization"] = fullToken;
    API.get("v1/users/profile")
      .then(res => {
        dispatch(setUser(res.data));
        dispatch(setUserLoaded(true));
      })
      .catch(e => {
        if (from === "checkLogin") {
          if (e && e.status === 404) {
            eraseCookie("accessToken");
            eraseCookie("expiresAt");
            eraseCookie("refreshToken");
            const notes = getState().snackbar.notifications;
            if (
              !notes ||
              !notes.find(note => note.message === "No user found")
            ) {
              dispatch(logout());

              dispatch(enqueueSnackbar({ message: "No user found" }));
            }
          }
        }
      });

    Promise.all([
      API.get("v1/stripe/payments"),
      API.get("v1/billing/details")
    ]).then(res => {
      const payment = res[0].data.find(payment => payment.default_pm);
      if (payment) dispatch(setPayment(payment));
      dispatch(setBillingDetails(res[1].data));
    });
  };
}

export function logout() {
  return dispatch => {
    dispatch(resetProject());
    dispatch({ type: RESET_ACCOUNT_STATE });
    eraseCookie("accessToken");
    eraseCookie("expiresAt");
    eraseCookie("refreshToken");
    window.dataLayer.push(function () {
      this.reset();
    });
    dispatch({
      type: LOGOUT,
      userData: {}
    });
  };
}
